import { useLocation, useNavigate } from 'react-router-dom';
import AppStatePage from './AppStatePage';
import { getAppSectionHome } from '../../utils/appSectionHome';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const home = getAppSectionHome(pathname);

  return (
    <AppStatePage
      statusCode="404 — Page Not Found"
      title="This page isn't available"
      message={`The link may be outdated, the feature may be unavailable, or the page may have been moved. Check the address or ${home.returnPhrase}.`}
      actions={[
        {
          label: home.label,
          onClick: () => navigate(home.path),
          ariaLabel: home.label,
        },
        {
          label: 'Go Back',
          variant: 'secondary',
          onClick: () => navigate(-1),
          ariaLabel: 'Go back to the previous page',
        },
      ]}
    />
  );
}
